:host {
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;
  grid-column-gap: calc(2 * var(--spacer));
}

@media screen and (min-width: 2560px) {
  :host {
    display: inline-grid;
  }
}
